import { getInPipelineStatuses } from '../_constants/admission-status'
import { EViewToggleButtonType } from './_components/application-view-button'

export type ApplicationsSearchParams = {
  search?: string
  view?: EViewToggleButtonType
  status?: string
  startDate?: string
  endDate?: string
  facilityId?: string
}

function createValidateSearch(defaultStatus: string) {
  return (search: Record<string, unknown>): ApplicationsSearchParams => ({
    search: typeof search.search === 'string' ? search.search : undefined,
    view: search.view === EViewToggleButtonType.KANBAN ? EViewToggleButtonType.KANBAN : undefined,
    status: typeof search.status === 'string' ? search.status : defaultStatus,
    startDate: typeof search.startDate === 'string' ? search.startDate : undefined,
    endDate: typeof search.endDate === 'string' ? search.endDate : undefined,
    facilityId: typeof search.facilityId === 'string' ? search.facilityId : undefined,
  })
}

export const validateStaffApplicationsSearch = createValidateSearch(
  getInPipelineStatuses().join(','),
)

// Tenant view starts stateless — no default status filter, so all statuses show.
export const validateTenantApplicationsSearch = createValidateSearch('')
